import script from "./TablaRooming.vue?vue&type=script&setup=true&lang=js"
export * from "./TablaRooming.vue?vue&type=script&setup=true&lang=js"

import "./TablaRooming.vue?vue&type=style&index=0&id=03a07003&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03a07003"]])

export default __exports__